module.exports = __webpack_public_path__ + "static/gift-certificates-53ce8edb86232128ae9d4ffb01f7deac.png";